import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

export var DEFAULT_ANSWER_STATUS_COLOR_TOOLTIPS = {
  correct: 'Correct',
  incorrect: 'Incorrect or score is 0',
  customGrade: 'Custom grade — score was set manually',
  skipped: 'Skipped',
  essay: 'Essay question'
};
export var getAnswerStatusColorTooltip = function getAnswerStatusColorTooltip(status, label) {
  if (!status || status === 'ungraded') {
    return undefined;
  }

  var tooltips = _objectSpread(_objectSpread({}, DEFAULT_ANSWER_STATUS_COLOR_TOOLTIPS), label);

  switch (status) {
    case 'correct':
      return tooltips.correct;

    case 'incorrect':
      return tooltips.incorrect;

    case 'manuallyAwarded':
      return tooltips.customGrade;

    case 'skipped':
      return tooltips.skipped;

    case 'essay':
      return tooltips.essay;

    default:
      return undefined;
  }
};